// import { useState, useEffect } from 'react';
// import { useSearchParams } from 'react-router-dom';
// import api, { grievancesAPI } from '../../services/api';
// import { toast } from 'react-hot-toast';
// import { Download, Printer } from 'lucide-react';
// import type { GrievanceStatus } from '../../services/api';
// import {
//   downloadGrievanceReport,
//   GrievanceDetail,
//   printGrievanceReport,
//   TimelineEntry,
// } from '../../utils/grievanceExport';

// export default function Reviews() {
//   const [searchParams] = useSearchParams();
//   const [grievanceId, setGrievanceId] = useState(() => searchParams.get('id') || '');
//   const [timeline, setTimeline] = useState<TimelineEntry[]>([]);
//   const [grievance, setGrievance] = useState<GrievanceDetail | null>(null);
//   const [recordId, setRecordId] = useState<number | null>(null);
//   const [currentStatus, setCurrentStatus] = useState<string>('');
//   const [status, setStatus] = useState('submitted');
//   const [message, setMessage] = useState('');
//   const [office, setOffice] = useState(' ');
//   const [eventDate, setEventDate] = useState('');

//   const loadTimeline = async () => {
//     if (!grievanceId) return;
//     try {
//       const [timelineRes, detailsRes] = await Promise.all([
//         grievancesAPI.getTimeline(grievanceId),
//         api.get(`/grievances/${grievanceId}`),
//       ]);
//       setTimeline(timelineRes.data?.data || []);
//       const data = detailsRes.data?.data || detailsRes.data;
//       setGrievance(data ?? null);
//       setRecordId(data?.id ?? null);
//       setCurrentStatus(data?.status ?? '');
//     } catch (e) {
//       setTimeline([]);
//       setGrievance(null);
//       setRecordId(null);
//       setCurrentStatus('');
//     }
//   };

//   useEffect(() => {
//     loadTimeline();
//   }, [grievanceId]);

//   const addEntry = async () => {
//     if (!grievanceId || !status || !message) {
//       toast.error('Please fill grievance ID, status, and message');
//       return;
//     }
//     try {
//       await grievancesAPI.addTimeline(grievanceId, { status, message, office, eventDate: eventDate || undefined });
//       toast.success('Timeline entry added');
//       setMessage('');
//       setEventDate('');
//       loadTimeline();
//     } catch (e: any) {
//       toast.error(e?.response?.data?.message || 'Failed to add entry');
//     }
//   };

//   const statuses = [
//     { value: 'submitted', label: 'दर्ता भयो' },
//     { value: 'approved', label: 'अनुमोदन भयो' },
//     { value: 'monitoring', label: 'अनुगमन हुँदैछ' },
//     { value: 'in-progress', label: 'कारवाही हुँदैछ' },
//     { value: 'resolved', label: 'समाधान भयो' },
//     { value: 'rejected', label: 'अस्वीकृत' },
//   ];

//   const systemStatuses = [
//     { value: 'pending', label: 'Pending' },
//     { value: 'in-progress', label: 'In Progress' },
//     { value: 'resolved', label: 'Resolved' },
//     { value: 'rejected', label: 'Rejected' },
//   ];

//   const updateGrievanceStatus = async (next: GrievanceStatus) => {
//     if (!recordId) {
//       toast.error('Load a valid grievance first');
//       return;
//     }

//     try {
//       await grievancesAPI.updateStatus(recordId, {
//         status: next,
//       });

//       toast.success('Grievance status updated');
//     } catch (e: any) {
//       toast.error(
//         e?.response?.data?.message || 'Failed to update status'
//       );
//     }
//   };

//   return (
//     <div className="p-6">
//       <h1 className="text-2xl font-bold mb-4">Reviews / Timeline</h1>

//       <div className="bg-white rounded-lg shadow p-4 mb-6 space-y-3">
//         <div className="flex gap-3 items-center">
//           <input
//             className="input"
//             placeholder="Grievance ID (e.g., CM_0001)"
//             value={grievanceId}
//             onChange={(e) => setGrievanceId(e.target.value)}
//           />
//           <button className="btn-outline" onClick={loadTimeline}>Load</button>
//           {grievance && (
//             <>
//               <button
//                 type="button"
//                 className="btn-outline inline-flex items-center gap-1"
//                 onClick={() => printGrievanceReport(grievance, timeline)}
//               >
//                 <Printer className="h-4 w-4" /> Print
//               </button>
//               <button
//                 type="button"
//                 className="btn-primary inline-flex items-center gap-1"
//                 onClick={async () => {
//                   try {
//                     await downloadGrievanceReport(grievance, timeline);
//                     toast.success('PDF downloaded');
//                   } catch {
//                     toast.error('Failed to generate PDF');
//                   }
//                 }}
//               >
//                 <Download className="h-4 w-4" /> Download PDF
//               </button>
//             </>
//           )}
//         </div>

//         {/* Inline grievance status update */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
//           <div>
//             <label className="label">Grievance Status</label>
//             <select className="input" value={currentStatus} onChange={(e) => setCurrentStatus(e.target.value)}>
//               {systemStatuses.map(s => (
//                 <option key={s.value} value={s.value}>{s.label}</option>
//               ))}
//             </select>
//           </div>
//           <div className="md:col-span-2">
//             <button className="btn-primary" onClick={updateGrievanceStatus} disabled={!recordId}>Update Status</button>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//           <div>
//             <label className="label">Status</label>
//             <select className="input" value={status} onChange={(e) => setStatus(e.target.value)}>
//               {statuses.map(s => (
//                 <option key={s.value} value={s.value}>{s.label}</option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="label">Date</label>
//             <input type="datetime-local" className="input" value={eventDate} onChange={(e) => setEventDate(e.target.value)} />
//           </div>
//           <div className="md:col-span-2">
//             <label className="label">Office</label>
//             <input className="input" value={office} onChange={(e) => setOffice(e.target.value)} />
//           </div>
//           <div className="md:col-span-2">
//             <label className="label">Message</label>
//             <textarea className="input" rows={3} placeholder="सन्देश" value={message} onChange={(e) => setMessage(e.target.value)} />
//           </div>
//         </div>

//         <div>
//           <button className="btn-primary" onClick={addEntry}>Add Entry</button>
//         </div>
//       </div>

//       <div className="bg-white rounded-lg shadow">
//         <div className="border-b px-4 py-2 text-sm text-gray-600">{timeline.length} entries</div>
//         <div className="divide-y">
//           {timeline.map(item => (
//             <div key={item.id} className="p-4">
//               <div className="text-sm text-gray-500">{new Date(item.eventDate).toLocaleString()}</div>
//               <div className="font-semibold capitalize">{item.status}</div>
//               <div className="text-gray-800 whitespace-pre-wrap">{item.message}</div>
//               {item.office && <div className="text-sm text-gray-600">{item.office}</div>}
//             </div>
//           ))}
//           {timeline.length === 0 && (
//             <div className="p-6 text-center text-gray-500 text-sm">No timeline entries</div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Download, Printer } from 'lucide-react';
import { toast } from 'react-hot-toast';

import api, {
  grievancesAPI,
  type GrievanceStatus,
} from '../../services/api';

import {
  downloadGrievanceReport,
  GrievanceDetail,
  printGrievanceReport,
  TimelineEntry,
} from '../../utils/grievanceExport';

const SYSTEM_STATUSES: {
  value: GrievanceStatus;
  label: string;
}[] = [
  {
    value: 'pending',
    label: 'Pending',
  },
  {
    value: 'in-progress',
    label: 'In Progress',
  },
  {
    value: 'resolved',
    label: 'Resolved',
  },
  {
    value: 'rejected',
    label: 'Rejected',
  },
];

const TIMELINE_STATUSES = [
  {
    value: 'submitted',
    label: 'दर्ता भयो',
  },
  {
    value: 'approved',
    label: 'अनुमोदन भयो',
  },
  {
    value: 'monitoring',
    label: 'अनुगमन हुँदैछ',
  },
  {
    value: 'in-progress',
    label: 'कारवाही हुँदैछ',
  },
  {
    value: 'resolved',
    label: 'समाधान भयो',
  },
  {
    value: 'rejected',
    label: 'अस्वीकृत',
  },
];

export default function Reviews() {
  const [searchParams] = useSearchParams();

  // -----------------------------------------
  // Grievance
  // -----------------------------------------

  const [grievanceId, setGrievanceId] = useState(
    () => searchParams.get('id') || ''
  );

  const [grievance, setGrievance] =
    useState<GrievanceDetail | null>(null);

  const [recordId, setRecordId] =
    useState<number | null>(null);

  // -----------------------------------------
  // Current grievance status
  // -----------------------------------------

  const [currentStatus, setCurrentStatus] =
    useState<GrievanceStatus>('pending');

  const [selectedStatus, setSelectedStatus] =
    useState<GrievanceStatus>('pending');

  const [isUpdatingStatus, setIsUpdatingStatus] =
    useState(false);

  // -----------------------------------------
  // Timeline
  // -----------------------------------------

  const [timeline, setTimeline] =
    useState<TimelineEntry[]>([]);

  const [timelineStatus, setTimelineStatus] =
    useState('submitted');

  const [message, setMessage] =
    useState('');

  const [office, setOffice] =
    useState('');

  const [eventDate, setEventDate] =
    useState('');

  const [isAddingTimeline, setIsAddingTimeline] =
    useState(false);

  // -----------------------------------------
  // Loading
  // -----------------------------------------

  const [isLoading, setIsLoading] =
    useState(false);

  // -----------------------------------------
  // Load grievance + timeline
  // -----------------------------------------

  const loadGrievance = async () => {
    const id = grievanceId.trim();

    if (!id) {
      toast.error('Please enter a valid grievance ID');
      return;
    }

    setIsLoading(true);

    try {
      const [timelineRes, detailsRes] =
        await Promise.all([
          grievancesAPI.getTimeline(id),
          api.get(`/grievances/${id}`),
        ]);

      // -----------------------------
      // Grievance data
      // -----------------------------

      const data =
        detailsRes.data?.data ??
        detailsRes.data;

      if (!data) {
        throw new Error('Grievance not found');
      }

      setGrievance(data);
      setRecordId(data.id ?? null);

      // -----------------------------
      // Current status
      // -----------------------------

      const backendStatus =
        data.status as GrievanceStatus;

      const validStatus =
        SYSTEM_STATUSES.some(
          (item) =>
            item.value === backendStatus
        );

      if (validStatus) {
        setCurrentStatus(backendStatus);
        setSelectedStatus(backendStatus);
      } else {
        setCurrentStatus('pending');
        setSelectedStatus('pending');
      }

      // -----------------------------
      // Timeline
      // -----------------------------

      setTimeline(
        timelineRes.data?.data ??
        timelineRes.data ??
        []
      );
    } catch (error: any) {
      console.error(
        'Failed to load grievance:',
        error
      );

      setGrievance(null);
      setRecordId(null);
      setTimeline([]);

      toast.error(
        error?.response?.data?.message ||
        'Failed to load grievance'
      );
    } finally {
      setIsLoading(false);
    }
  };

  // -----------------------------------------
  // Initial load from URL
  // -----------------------------------------

  useEffect(() => {
    const id = searchParams.get('id');

    if (id) {
      setGrievanceId(id);
    }
  }, [searchParams]);

  // -----------------------------------------
  // Update grievance status
  // -----------------------------------------

  const updateGrievanceStatus = async () => {
    if (!recordId) {
      toast.error(
        'Please load a valid grievance first'
      );
      return;
    }

    // No duplicate API request
    if (isUpdatingStatus) {
      return;
    }

    // Nothing changed
    if (selectedStatus === currentStatus) {
      toast('No status change detected');
      return;
    }

    setIsUpdatingStatus(true);

    try {
      await grievancesAPI.updateStatus(
        recordId,
        {
          status: selectedStatus,
        }
      );

      // Update local state immediately
      setCurrentStatus(selectedStatus);

      // Update grievance object as well
      setGrievance((previous) =>
        previous
          ? {
              ...previous,
              status: selectedStatus,
            }
          : previous
      );

      toast.success(
        'Grievance status updated successfully'
      );
    } catch (error: any) {
      console.error(
        'Failed to update status:',
        error
      );

      toast.error(
        error?.response?.data?.message ||
        'Failed to update grievance status'
      );
    } finally {
      setIsUpdatingStatus(false);
    }
  };

  // -----------------------------------------
  // Add timeline entry
  // -----------------------------------------

  const addTimelineEntry = async () => {
    const id = grievanceId.trim();

    if (!id) {
      toast.error(
        'Please load a valid grievance first'
      );
      return;
    }

    if (!message.trim()) {
      toast.error(
        'Please enter a timeline message'
      );
      return;
    }

    if (isAddingTimeline) {
      return;
    }

    setIsAddingTimeline(true);

    try {
      await grievancesAPI.addTimeline(
        id,
        {
          status: timelineStatus,
          message: message.trim(),
          office: office.trim(),
          eventDate:
            eventDate || undefined,
        }
      );

      toast.success(
        'Timeline entry added successfully'
      );

      // Clear form
      setMessage('');
      setEventDate('');
      setOffice('');

      // Reload timeline to get the server-generated
      // entry and prevent local duplicate insertion
      const timelineRes =
        await grievancesAPI.getTimeline(id);

      setTimeline(
        timelineRes.data?.data ??
        timelineRes.data ??
        []
      );
    } catch (error: any) {
      console.error(
        'Failed to add timeline entry:',
        error
      );

      toast.error(
        error?.response?.data?.message ||
        'Failed to add timeline entry'
      );
    } finally {
      setIsAddingTimeline(false);
    }
  };

  // -----------------------------------------
  // Print report
  // -----------------------------------------

  const handlePrint = () => {
    if (!grievance) {
      toast.error(
        'Please load a grievance first'
      );
      return;
    }

    printGrievanceReport(
      grievance,
      timeline
    );
  };

  // -----------------------------------------
  // Download PDF
  // -----------------------------------------

  const handleDownload = async () => {
    if (!grievance) {
      toast.error(
        'Please load a grievance first'
      );
      return;
    }

    try {
      await downloadGrievanceReport(
        grievance,
        timeline
      );

      toast.success(
        'PDF downloaded successfully'
      );
    } catch (error) {
      console.error(
        'Failed to generate PDF:',
        error
      );

      toast.error(
        'Failed to generate PDF'
      );
    }
  };

  return (
    <div className="p-6">

      {/* ======================================
          PAGE HEADER
      ======================================= */}

      <div className="mb-6">
        <h1 className="text-2xl font-bold">
          Reviews / Timeline
        </h1>

        <p className="text-sm text-gray-500 mt-1">
          View grievance details, update current
          status, and manage grievance history.
        </p>
      </div>

      {/* ======================================
          SEARCH GRIEVANCE
      ======================================= */}

      <div className="bg-white rounded-lg shadow p-4 mb-6">

        <div className="flex flex-col md:flex-row gap-3">

          <input
            className="input flex-1"
            placeholder="Grievance ID (e.g., CM_0001)"
            value={grievanceId}
            onChange={(e) =>
              setGrievanceId(e.target.value)
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                loadGrievance();
              }
            }}
          />

          <button
            type="button"
            className="btn-outline"
            onClick={loadGrievance}
            disabled={isLoading}
          >
            {isLoading
              ? 'Loading...'
              : 'Load Grievance'}
          </button>

        </div>

      </div>

      {/* ======================================
          GRIEVANCE CONTENT
      ======================================= */}

      {grievance && (
        <>
          {/* ==================================
              GRIEVANCE ACTIONS
          =================================== */}

          <div className="bg-white rounded-lg shadow p-4 mb-6">

            <div className="flex flex-wrap gap-3">

              <button
                type="button"
                className="btn-outline inline-flex items-center gap-1"
                onClick={handlePrint}
              >
                <Printer className="h-4 w-4" />
                Print
              </button>

              <button
                type="button"
                className="btn-primary inline-flex items-center gap-1"
                onClick={handleDownload}
              >
                <Download className="h-4 w-4" />
                Download PDF
              </button>

            </div>

          </div>

          {/* ==================================
              CURRENT STATUS
          =================================== */}

          <div className="bg-white rounded-lg shadow p-4 mb-6">

            <h2 className="font-semibold text-lg mb-4">
              Grievance Status
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">

              <div>
                <label className="label">
                  Current Status
                </label>

                <div className="input bg-gray-100">
                  {
                    SYSTEM_STATUSES.find(
                      (item) =>
                        item.value ===
                        currentStatus
                    )?.label
                  }
                </div>
              </div>

              <div>
                <label className="label">
                  Change Status
                </label>

                <select
                  className="input"
                  value={selectedStatus}
                  onChange={(e) =>
                    setSelectedStatus(
                      e.target.value as GrievanceStatus
                    )
                  }
                  disabled={isUpdatingStatus}
                >
                  {SYSTEM_STATUSES.map(
                    (item) => (
                      <option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </option>
                    )
                  )}
                </select>
              </div>

              <div>
                <button
                  type="button"
                  className="btn-primary w-full"
                  onClick={
                    updateGrievanceStatus
                  }
                  disabled={
                    !recordId ||
                    isUpdatingStatus ||
                    selectedStatus ===
                      currentStatus
                  }
                >
                  {isUpdatingStatus
                    ? 'Updating...'
                    : 'Update Status'}
                </button>
              </div>

            </div>

          </div>

          {/* ==================================
              ADD TIMELINE ENTRY
          =================================== */}

          <div className="bg-white rounded-lg shadow p-4 mb-6">

            <h2 className="font-semibold text-lg mb-4">
              Add Timeline Entry
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              {/* Timeline Status */}

              <div>
                <label className="label">
                  Timeline Status
                </label>

                <select
                  className="input"
                  value={timelineStatus}
                  onChange={(e) =>
                    setTimelineStatus(
                      e.target.value
                    )
                  }
                  disabled={isAddingTimeline}
                >
                  {TIMELINE_STATUSES.map(
                    (item) => (
                      <option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </option>
                    )
                  )}
                </select>
              </div>

              {/* Event Date */}

              <div>
                <label className="label">
                  Date
                </label>

                <input
                  type="datetime-local"
                  className="input"
                  value={eventDate}
                  onChange={(e) =>
                    setEventDate(
                      e.target.value
                    )
                  }
                  disabled={isAddingTimeline}
                />
              </div>

              {/* Office */}

              <div className="md:col-span-2">

                <label className="label">
                  Office
                </label>

                <input
                  className="input"
                  placeholder="Enter office name"
                  value={office}
                  onChange={(e) =>
                    setOffice(
                      e.target.value
                    )
                  }
                  disabled={isAddingTimeline}
                />

              </div>

              {/* Message */}

              <div className="md:col-span-2">

                <label className="label">
                  Message
                </label>

                <textarea
                  className="input"
                  rows={4}
                  placeholder="सन्देश लेख्नुहोस्..."
                  value={message}
                  onChange={(e) =>
                    setMessage(
                      e.target.value
                    )
                  }
                  disabled={isAddingTimeline}
                />

              </div>

            </div>

            <div className="mt-4">

              <button
                type="button"
                className="btn-primary"
                onClick={
                  addTimelineEntry
                }
                disabled={
                  isAddingTimeline ||
                  !message.trim()
                }
              >
                {isAddingTimeline
                  ? 'Adding...'
                  : 'Add Timeline Entry'}
              </button>

            </div>

          </div>

      {/* ======================================
          TIMELINE HISTORY
      ======================================= */}

          <div className="bg-white rounded-lg shadow overflow-hidden">

            {/* Header */}
            <div className="border-b px-4 py-3">

              <h2 className="font-semibold text-lg">
                Grievance Timeline
              </h2>

              <p className="text-sm text-gray-500 mt-1">
                {timeline.length}{' '}
                {timeline.length === 1
                  ? 'entry'
                  : 'entries'}
              </p>

            </div>

            {/* Timeline List */}
            <div className="divide-y">

              {timeline.map((item) => (

                <div
                  key={item.id}
                  className="p-4 min-w-0 overflow-hidden"
                >

                  <div className="flex flex-col md:flex-row md:justify-between gap-4">

                    {/* Timeline Content */}
                    <div className="min-w-0 flex-1">

                      {/* Status */}
                      <div className="font-semibold capitalize break-words">
                        {item.status.replace('-', ' ')}
                      </div>

                      {/* Message */}
                      <div className="text-gray-800 mt-1 whitespace-pre-wrap break-words overflow-wrap-anywhere max-w-full">
                        {item.message}
                      </div>

                      {/* Office */}
                      {item.office && (
                        <div className="text-sm text-gray-600 mt-2 break-words overflow-wrap-anywhere max-w-full">
                          <span className="font-medium">
                            Office:
                          </span>{' '}
                          {item.office}
                        </div>
                      )}

                    </div>

                    {/* Event Date */}
                    <div className="text-sm text-gray-500 shrink-0 md:text-right">
                      {new Date(
                        item.eventDate
                      ).toLocaleString()}
                    </div>

                  </div>

                </div>

              ))}

              {/* Empty State */}
              {timeline.length === 0 && (

                <div className="p-6 text-center text-gray-500 text-sm">
                  No timeline entries found.
                </div>

              )}

            </div>

          </div>
        </>
      )}

      {/* ======================================
          EMPTY STATE
      ======================================= */}

      {!grievance && !isLoading && (

        <div className="bg-white rounded-lg shadow p-10 text-center text-gray-500">

          Enter a grievance ID and click
          <strong className="mx-1">
            Load Grievance
          </strong>
          to view the grievance.

        </div>

      )}

    </div>
  );
}